(function () {
  var root = document.querySelector('.vc');
  var row = document.querySelector('[data-vc-row]');
  if (!root || !row) return;

  var prevBtn = document.querySelector('[data-vc-prev]');
  var nextBtn = document.querySelector('[data-vc-next]');
  var items = Array.prototype.slice.call(row.querySelectorAll('.vc__item'));
  var active = null;
  var inView = false;
  var scrollTimer = null;

  function videoOf(item) {
    return item ? item.querySelector('.vc__video') : null;
  }

  // Posters load only when the carousel is close to the viewport (keeps them off the critical path).
  function loadPosters() {
    items.forEach(function (it) {
      var v = videoOf(it);
      if (v && v.getAttribute('data-poster')) {
        v.setAttribute('poster', v.getAttribute('data-poster'));
        v.removeAttribute('data-poster');
      }
    });
  }

  if ('IntersectionObserver' in window) {
    var posterObserver = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) {
        loadPosters();
        posterObserver.disconnect();
      }
    }, { rootMargin: '600px 0px' });
    posterObserver.observe(root);
  } else {
    loadPosters();
  }

  function nearestToCenter() {
    var rect = row.getBoundingClientRect();
    var cx = rect.left + rect.width / 2;
    var best = items[0];
    var bestDist = Infinity;
    items.forEach(function (it) {
      var r = it.getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - cx);
      if (d < bestDist) { bestDist = d; best = it; }
    });
    return best;
  }

  function show(index) {
    if (index < 0) index = 0;
    if (index > items.length - 1) index = items.length - 1;
    items[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  function tryPlay(item) {
    var v = videoOf(item);
    if (!v) return;
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('playsinline', '');
    if (v.preload !== 'auto') v.preload = 'auto';
    var p;
    try { p = v.play(); } catch (e) { p = null; }
    if (p && p.catch) {
      p.catch(function () { item.classList.add('is-paused'); });
    }
  }

  function setActive(item, force) {
    if (!item) return;
    if (item === active && !force) {
      var cur = videoOf(item);
      if (cur && cur.paused && !item.dataset.userPaused && inView) tryPlay(item);
      return;
    }
    items.forEach(function (it) {
      var isActive = it === item;
      it.classList.toggle('is-active', isActive);
      if (!isActive) {
        var v = videoOf(it);
        if (v && !v.paused) v.pause();
        it.classList.remove('is-paused');
        delete it.dataset.userPaused;
      }
    });
    active = item;
    var idx = items.indexOf(item);
    [idx - 1, idx + 1].forEach(function (n) {
      var nv = videoOf(items[n]);
      if (nv && nv.preload !== 'auto') nv.preload = 'auto';
    });
    if (inView && !document.hidden) tryPlay(item);
  }

  items.forEach(function (item) {
    var v = videoOf(item);
    if (!v) return;
    v.addEventListener('playing', function () { item.classList.remove('is-paused'); });
    v.addEventListener('pause', function () {
      if (item === active && !v.ended) item.classList.add('is-paused');
    });
    v.addEventListener('canplay', function () {
      if (item === active && v.paused && inView && !item.dataset.userPaused && !document.hidden) tryPlay(item);
    });
    item.addEventListener('click', function () {
      if (item !== active) {
        item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        setActive(item, true);
        tryPlay(item);
        return;
      }
      if (v.paused) {
        delete item.dataset.userPaused;
        tryPlay(item);
      } else {
        item.dataset.userPaused = '1';
        v.pause();
      }
    });
  });

  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); show(items.indexOf(active || nearestToCenter()) - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); show(items.indexOf(active || nearestToCenter()) + 1); });

  row.addEventListener('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () { setActive(nearestToCenter()); }, 140);
  }, { passive: true });

  function resume() {
    if (inView && active && !document.hidden && !active.dataset.userPaused) tryPlay(active);
  }

  // Browsers can block autoplay (low power mode, data saver); retry on the first user gesture.
  ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (evt) {
    window.addEventListener(evt, resume, { once: true, passive: true });
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      var v = videoOf(active);
      if (v && !v.paused) v.pause();
    } else {
      resume();
    }
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        inView = entry.isIntersecting && entry.intersectionRatio >= 0.25;
        if (inView) {
          setActive(active || nearestToCenter());
          resume();
        } else {
          var v = videoOf(active);
          if (v && !v.paused) v.pause();
        }
      });
    }, { threshold: [0, 0.25, 0.6] }).observe(root);
  } else {
    inView = true;
    setActive(nearestToCenter());
  }
})();